import { call, put, all, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import * as actions from './actions';
import * as types from '../types';
import axios from '../../../services/axios';
import history from '../../../services/history';

function* loginRequest({ payload }) {
  try {
    const response = yield call(axios.post, '/tokens', payload);
    console.log(response.data);
    yield put(actions.loginSuccess({ ...response.data }));

    toast.success('Sucesso! Login realizado!');

    axios.defaults.headers.Authorization = `Bearer ${response.data.token}`;

    history.push('/main');
  } catch (error) {
    toast.error('Usuário ou Senha inválidos');
    yield put(actions.loginFailure());
  }
}

function persistRehydrate({ payload }) {
  const token = get(payload, 'auth.token', '');
  if (!token) return;
  axios.defaults.headers.Authorization = `Bearer ${token}`;
}

function* registerRequest({ payload }) {
  const {
    id,
    email,
    telephoneNumber,
    cep,
    address,
    addressNumber,
    additionalInformation,
    neighborhood,
    city,
    password,
    firstAccess,
  } = payload;

  try {
    if (id) {
      yield call(axios.put, '/users', {
        id,
        email,
        telephoneNumber,
        cep,
        address,
        addressNumber,
        additionalInformation,
        neighborhood,
        city,
        password: password || undefined,
        firstAccess,
      });
      toast.success('Cadastro atualizado!');
      yield put(actions.registerUpdatedSuccess({ email, password }));
    }
  } catch (e) {
    console.log(e);
    const errors = get(e, 'response.data.error', []);
    const status = get(e, 'response.status', 0);

    if (status === 401) {
      toast.error('Você pracisa fazer o login novamente');
      yield put(actions.loginFailure());
      return history.push('/login');
    }

    if (errors.length > 0) {
      errors.map((error) => toast.error(error));
    } else {
      toast.error('Erro desconhecido');
    }
    yield put(actions.registerFailure());
  }
}

function* firstAccessResquest({ payload }) {
  const { id, password, firstAccess } = payload;

  try {
    if (id) {
      yield call(axios.put, '/users', {
        id,
        password: password || undefined,
        firstAccess,
      });
      toast.success('Senha atualizada');
      yield put(actions.passwordUpdatedSuccess({ firstAccess }));
      return history.push('/login');
    }
  } catch (e) {
    console.log(e);
    const errors = get(e, 'response.data.error', []);
    const status = get(e, 'response.status', 0);

    if (status === 401) {
      toast.error('Você pracisa fazer o login novamente');
      yield put(actions.loginFailure());
      return history.push('/login');
    }

    if (errors.length > 0) {
      errors.map((error) => toast.error(error));
    } else {
      toast.error('Erro desconhecido');
    }
    yield put(actions.registerFailure());
  }
}

export default all([
  takeLatest(types.LOGIN_REQUEST, loginRequest),
  takeLatest(types.PERSIST_REHYDRATE, persistRehydrate),
  takeLatest(types.REGISTER_REQUEST, registerRequest),
  takeLatest(types.PASSWORD_UPDATE_REQUEST, firstAccessResquest),
]);
